import { render } from "./Header.vue?vue&type=template&id=43d54e66&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=43d54e66&lang=scss&scoped=true"

import exportComponent from "/Users/benjamin_nalo/Ben/portfolio-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d54e66"]])

export default __exports__